/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsClearingV1SweepTargetStatsState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_CLEARING_V1_SWEEP_TARGET_STATS_STATE_ENTITY_NAME = 'ixc.sweeps.clearing.v1.SweepTargetStats';
export const ixcSweepsClearingV1SweepTargetStatsStateEntity = new schema.Entity<IxcSweepsClearingV1SweepTargetStatsState>(IXC_SWEEPS_CLEARING_V1_SWEEP_TARGET_STATS_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcSweepsClearingV1SweepTargetStatsState) => `${entity.sweepTargetId}-${entity.firstDayOfMonth}` });

